import { useEffect, useState } from "react";
import useAppData from "../../hook/useAppData";
import logo from "../../image/logoWithoutName.svg";

import "./index.scss";
import { getProjectsChartsDate } from "./services";
import { currentDate, _formatDate } from "../../libs/dateUtils";
import { BarChart, XAxis, YAxis, Tooltip, Legend, Bar } from "recharts";
import { Redirect } from "react-router-dom";

function Dashboard() {
  const { profileId } = useAppData();
  return <> {profileId ? <DashboardData /> : <Redirect to="/" />}</>;
}

export default Dashboard;

type IDataOfRechatsData = {
  id: number;
  name: string;
  expected: number;
  appointed: number;
};

const DashboardData = () => {
  const { token } = useAppData();
  const [datas, setDatas] = useState([] as any[]);

  useEffect(() => {
    getProjectsDate();
  }, []);

  async function getProjectsDate() {
    const queryString = `year=${getYear()}&month=${getMonth() + 1}`;
    const data = await getProjectsChartsDate(token, queryString);
    const dataFormated = formatData(data);
    setDatas(dataFormated || []);
  }

  const formatData = (data: any[]): IDataOfRechatsData[] => {
    return data
      ?.map((item): IDataOfRechatsData => {
        return {
          id: item.id,
          name: item.name,
          appointed: item.hours.appointed,
          expected: item.hours.predicted,
        };
      })
      .filter((item) => item.appointed || item.expected);
  };
  const getMonth = () => new Date(_formatDate(currentDate())).getMonth();

  const getYear = () => new Date(_formatDate(currentDate())).getFullYear();

  //   async function getCollaboratorDate(id = 0) {
  //     if (!id) return;
  //     const queryString = `year=${getYear()}&month=${getMonth() + 1}&projectId=${id}`;
  //     const data = await getCollaboratorChartsDate(token, queryString);
  //     setChartsPoints(data?.chartsPoins);
  //     setProjectName(data?.projectName);
  //   }

  return (
    <>
      <div className="containerHome flex flex-col items-center">
        <img src={logo} alt="logo" className="w-36 h-36 -my-6" />
        <h2 className="tittle font-poppins">Bem-vindo(a) ao Sistema IntegraAdmin</h2>
      </div>
      <div className="rounded-xl w-full flex justify-center">
        <div
          className="w-full h-full bg-white rounded-xl shadow-xl text-1.4rem -ml-8 pt-16 px-12 pb-4"
          style={{ maxWidth: (window.screen.width * 70) / 100, overflow: "auto" }}
        >
          <BarChart
            data={datas}
            width={window.screen.width}
            height={(window.screen.height * 60) / 100}
            margin={{ right: 10 }}
            className="-ml-8 rounded-xl"
          >
            <XAxis dataKey="name" angle={-30} tickMargin={10} />
            <YAxis />
            <Tooltip />
            <Legend margin={{ top: 30 }} />
            <Bar
              dataKey="appointed"
              name="Apontado"
              // onClick={(e) => console.log(e)}
              barSize={(window.screen.width * 5) / 100}
              fill="var(--primary)"
            />
            <Bar
              dataKey="expected"
              name="Esperado"
              // onClick={(e) => console.log(e)}
              barSize={(window.screen.width * 5) / 100}
              fill="var(--secondary)"
            />
          </BarChart>
        </div>
      </div>
    </>
  );
};
